import { API_BASE, getAuthHeaders } from './config';

export async function fetchDashboardOverview() {
    const res = await fetch(`${API_BASE}/admin/dashboard/overview`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<{
        users_total: number; users_new_last7: number; premium_active: number; premium_share: number;
        contents_total: number; contents_visible: number; contents_premium: number;
        errors_pending: number; errors_new_last7: number;
        ratings_avg: number; ratings_count: number;
        reads_7d: number; listens_7d: number;
    }>;
}

export async function fetchDashboardRecent() {
    const res = await fetch(`${API_BASE}/admin/dashboard/recent`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<{
        recent_contents: Array<{ id: number; title: string; is_premium: boolean; is_visible: boolean; created_at: string }>;
        recent_errors: Array<{ id: string; type: 'TEXT' | 'AUDIO' | 'APP'; is_resolved: boolean; reported_at: string; user_email: string | null }>;
        recent_users: Array<{ id: string; email: string; is_premium: boolean; created_at: string }>;
    }>;
}

export async function fetchDashboardTopTags() {
    const res = await fetch(`${API_BASE}/admin/dashboard/top-tags`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<{ items: Array<{ id: number; name: string; count: number }> }>;
}

// NOWE:
export async function fetchDashboardAnalytics() {
    const res = await fetch(`${API_BASE}/admin/dashboard/analytics`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<{ items: Array<{ label: string; value: number | string }> }>;
}

export type DashboardSystemResponse = {
    app_uptime_seconds: number;
    db_latency_ms: number;
    app_status: 'OK' | 'DEGRADED' | 'DOWN';
    db_status: 'OK' | 'DEGRADED' | 'DOWN';
    cdn_status: 'OK' | 'DEGRADED' | 'DOWN' | 'UNKNOWN';
    cpu: {
        process_percent: number;
        system_percent_approx: number;
        load_1m: number;
        cores: number;
    };
    memory: {
        process_mb: number;
    };
};

export async function fetchDashboardSystem() {
    const res = await fetch(`${API_BASE}/admin/dashboard/system`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<DashboardSystemResponse>;
}